import React from "react";

import classNames from "classnames";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/pro-light-svg-icons";

import Button from "ui/Button";
import CopyToClipboard, {
  Props as CopyToClipboardProps,
} from "ui/CopyToClipboard";

import styles from "./style.module.scss";

type Props = Pick<CopyToClipboardProps, "content" | "className"> & {
  hidden?: boolean;
  onReveal?: () => void;
};

function RevealableCopyIcon({ content, className, hidden, onReveal }: Props) {
  if (hidden) {
    return (
      <Button
        bare
        variant="link"
        className={classNames(styles.icon, className)}
        onClick={onReveal}
        title="Show"
      >
        <FontAwesomeIcon icon={faEye} />
      </Button>
    );
  }

  return (
    <CopyToClipboard
      className={classNames(styles.icon, className)}
      content={content}
      label=""
      title="Copy to clipboard"
    />
  );
}

export default RevealableCopyIcon;
